<template>
    <div class="header-bar">
        <div class="title">{{systemTitle}}</div>
        <div class="custom-bar">
            <component v-bind:is="customBar"></component>
        </div>
        <el-dropdown class="userinfo" placement="bottom" :hide-on-click="hideOnClick" >
            <span class="el-dropdown-link">
            {{nickname}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
               <el-dropdown-item class="userinfo-menu-item" @click.native.prevent="changePassword">修改密码</el-dropdown-item>
                <el-dropdown-item class="userinfo-menu-item" @click.native.prevent="logout">退&nbsp;出</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import config from '@/config/config';
export default {
    name: "TopHeader",
    data()
    {
        return {
            username: this.$store.getters['session/getUsername'],
            nickname: this.$store.getters['session/getNickname'],
            hideOnClick: false,
            systemTitle: this.$root.$data.system.title,
        }
    },
    methods:
    {
        logout()
        {
            return Fx.Http.post('/system/user/logout').
            then((response) =>
            {
                if(response.isSuccess() && response.getData('result'))
                {
                    this.$message({
                        message: '退出成功',
                        type: 'success',
                        duration: 800,
                        onClose: ()=>
                        {
                            console.log('process.env.NODE_ENV:',process.env.NODE_ENV)
                            window.location.reload();
                            // if(process.env.NODE_ENV == 'development')
                            // {
                            //     window.location.href = '/index.html';
                            // } else
                            // {
                            //     window.location.href = '/index.html';
                            // }
                        }
                    });
                }
                else
                {
                    this.$message.error(response.getErrorMessage());
                }
            });
        },
        changePassword()
        {
            this.dispatchOpenTab('/user/changePassword', null, {caption: "修改密码"});
        }
    },
    computed: {
        customBar: function()
        {
            return this.$store.getters['layout/getCustomBarName']
        }
    }
}
</script>

<style scoped>
.header-bar
{
    flex: 1;
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;
    justify-content: space-between;
    color: #ffffff;
    align-items: center;
    padding: 0px 130px;
    box-sizing: border-box;
}
.header-bar .title
{
    font-size: 23px;
}
.header-bar .custom-bar
{
    display: flex;
    flex: 1;
    height: 100%;
}
.userinfo
{
    color: #ffffff;
}
.el-dropdown-link {
    cursor: pointer;
}
.userinfo-menu-item
{
    min-width: 80px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/common/pages/index/component/TopHeader.vue